const endPoint = 'https://plusphysio-new-api.ifourtechlab.com';
const apiVersion = 'v2';

export const environment = {
  environmentType: 'plusphysio',
  appVersion: require("../../package.json").version, //Fetching vesion of application.

  production: true,
  endPoint: endPoint,
  apiVersion: apiVersion,
  apiUrl: `${endPoint}/api/${apiVersion}`

};
